"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseJSON = exports.checkStatus = exports.API_ROOT = exports.REGISTER_ENQUIRY_LOADER = exports.QUERY_TYPE = exports.USER_DETAILS = exports.DATE = exports.ENQUIRY_FOR = exports.COMMENT = exports.COUNTRY_CODE = exports.PHONE = exports.EMAIL = exports.MEMBERS = exports.PREV_STEP = exports.LAST_STEP = exports.NEXT_STEP = exports.SOURCE = void 0;
var SOURCE = "SOURCE";
exports.SOURCE = SOURCE;
var NEXT_STEP = "NEXT_STEP";
exports.NEXT_STEP = NEXT_STEP;
var LAST_STEP = "LAST_STEP";
exports.LAST_STEP = LAST_STEP;
var PREV_STEP = "PREV_STEP";
exports.PREV_STEP = PREV_STEP;
var MEMBERS = "MEMBERS";
exports.MEMBERS = MEMBERS;
var EMAIL = "EMAIL";
exports.EMAIL = EMAIL;
var PHONE = "PHONE";
exports.PHONE = PHONE;
var COUNTRY_CODE = "COUNTRY_CODE";
exports.COUNTRY_CODE = COUNTRY_CODE;
var COMMENT = "COMMENT";
exports.COMMENT = COMMENT;
var ENQUIRY_FOR = "ENQUIRY_FOR";
exports.ENQUIRY_FOR = ENQUIRY_FOR;
var DATE = "DATE";
exports.DATE = DATE;
var USER_DETAILS = "USER_DETAILS";
exports.USER_DETAILS = USER_DETAILS;
var QUERY_TYPE = "QUERY_TYPE";
exports.QUERY_TYPE = QUERY_TYPE;
var REGISTER_ENQUIRY_LOADER = "REGISTER_ENQUIRY_LOADER";
exports.REGISTER_ENQUIRY_LOADER = REGISTER_ENQUIRY_LOADER;
var API_ROOT = "/api/web/vdev/";
exports.API_ROOT = API_ROOT;

var checkStatus = function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = {
      status_code: response.status,
      status_text: response.statusText,
      data: response.json()
    };
    throw error;
  }
};

exports.checkStatus = checkStatus;

var parseJSON = function parseJSON(response) {
  return response.json();
};

exports.parseJSON = parseJSON;